import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'isInvaild'
})
export class IsInvaildPipe implements PipeTransform {

  transform(value: any ,returnT:any,returnF:any): boolean {
    let judge = true;
  
    switch (typeof value) {
      case 'string':
        if(!value || value.trim().length<1 )
          judge = false;
        break;

      case 'number':
        if(!value || value<0 )
          judge = false;
        break;  

      default : 
        judge = false;
        break;  
    }
     
    return judge ? returnT : returnF;
  }

}
